import { ru } from './ru';

export const en: typeof ru = {
  BASE: {
    REQUIRED: 'Required field',
    CANCEL: 'Cancel',
    BACK: 'Back',
    REGISTRATION: 'Registration',
    SUCCESS: 'Success',
    ERROR: 'Error',
  },
  LANGUAGE: {
    RU: 'ru',
    EN: 'eng',
    JP: 'jp',
  },
  FORM_LANGUAGES: {
    RUSSIAN: 'Russian',
    ENGLISH: 'English',
    JAPAN: 'Japanese',
  },
  AUTHORIZATION: {
    TITLE: 'Sign in',
    INPUT_LOGIN: 'Enter your login',
    LOGIN: 'Login',
    INPUT_PASSWORD: 'Enter your password',
    PASSWORD: 'Password',
    SIGN_IN: 'Sign in',
    RESTORE_PASSWORD: 'Restore password',
  },
  RESTORE_PASSWORD: {
    TITLE: 'Restore password',
    INPUT_LOGIN: 'Enter your login',
    LOGIN: 'Login',
    RESET: 'Reset',
    SUCCESS: 'Instructions have been sent by email',
    SIGN_IN: 'Sign in',
    USER_NOT_FOUND: 'User not found',
  },
  CHANGE_PASSWORD: {
    TITLE: 'Change password',
    INPUT_NEW_PASSWORD: 'Enter a new password!',
    INPUT_PASSWORD: 'Enter password',
    REPEAT_PASSWORD: 'Repeat password',
    PASSWORD_NOT_MATCH: 'Passwords do not match',
    CHANGE: 'Change',
    SIGN_IN: 'Sign in',
    CHANGED: 'Password changed',
  },
  PROFILE: {
    MAIN_LINK: 'Home',
    TITLE: 'Profile',
    NAME: 'Name',
    EMAIL: 'Email',
    INCORRECT_EMAIL: 'Invalid email address',
    PHONE: 'Phone',
    TELEGRAM: 'Telegram',
    TELEGRAM_CONNECTED: 'Connected',
    CONNECT: 'Connect',
    USER_UPDATE: 'Edit profile',
    REQUIRED_FIELD: 'Required field',
    DEFAULT_LANGUAGE: 'Default language',
    UPDATE: 'Update',
    CHANGE_PASSWORD: 'Change password',
    OLD_PASSWORD: 'Old password',
    NEW_PASSWORD: 'New password',
    CONFIRM_PASSWORD: 'Confirm password',
    CONFIRM: 'Are you sure?',
    CHANGE_PASSWORD_BTN: 'Change',
    LANGUAGE: 'Language',
    CHANGE_LANG_RUS: 'Russian',
    CHANGE_LANG_ENG: 'English',
    CHANGE_LANG_JPN: 'Japanese',
    CANCEL: 'Cancel',
  },
  MUTATION: {
    ERROR: 'Error',
    SUCCESS: 'Success',
    PARTIAL: 'Partial',
  },
  LOGIN: {
    SEND_EMAIL: 'A password reset link has been sent to your email',
  },
  COUNTERPARTY_REGISTRATION: {
    FILL_FORM: 'Fill out the form',
    ACCEPT_DOC: 'By creating an account, you agree to',
    SUCCESS_REGISTRATION: 'Registration completed',
    COMPANY_NAME: 'Company name',
    POSTAL_CODE: 'Postal code',
    COMPANY_REGISTRATION_DATE: 'Company registration date',
    COMPANY_REGISTRATION_NUMBER: 'Company registration number',
    COMPANY_INVOICE_NUMBER: 'Company invoice number',
    CONTACT_PERSON: 'Contact person',
    PHONE: 'Phone',
    FAX: 'Fax',
    EMAIL: 'Email',
    COMMENT: 'Comment',
    LANGUAGE: 'Language',
    ACCEPT: 'Register account',
    BACK_TO_SITE: 'Back to site',
    CUSTOMER: 'Customer',
    SUPPLIER: 'Supplier',
    JAPAN_JURISDICTION: 'Japanese law',
    INTERNATIONAL_JURISDICTION: 'International law',
    CHOOSE_COUNTRY: 'Select country',
    JAPAN_INDIVIDUAL_REGISTRATION: 'Individual',
    JAPAN_JURISTIC_PERSON_REGISTRATION: 'Legal entity',
    INTERNATIONAL_INDIVIDUAL_REGISTRATION: 'Individual',
    INTERNATIONAL_JURISTIC_PERSON_REGISTRATION: 'Legal entity',
    FULL_NAME: 'Full name',
    COMPANY_ADDRESS: 'Company address',
    IMPORT_COMMODITY: 'Main import commodity',
    CARS: 'Cars',
    PARTS: 'Parts',
    COUNTERPARTY_TYPE: 'Select type of cooperation',
    COUNTERPARTY_SUPPLIER_FORM: 'Supplier registration form',
    COUNTERPARTY_CUSTOMER_COUNTRY: 'Select your jurisdiction country',
    CHOOSE_ORGANIZATION_TYPE: 'Select organization type',
    FILL_COMPANY_FORM: 'Fill in your company information',
    FILL_INDIVIDUAL_FORM: 'Fill in your individual information',
    REGISTERED_ADDRESS: 'Registered address',
    ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',
    LOGIN: 'Login',
    TERMS_OF_USE_AND_PRIVACY_POLICY: 'Terms of use & Privacy Policy',
    DELETE_NOTE: 'If you wish to delete your account, please contact us at this email address:',
    FULL_ADDRESS: 'Full address',
    SAME_WITH_PHONE: 'Same as phone',
    ENGINE: 'Engine',
  },
  NOTIFICATIONS: {
    UNNAMED_NOTIFICATION: 'Unknown notification',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    LOCKED: 'Locked',
    NOTIFICATIONS: 'Notifications',
    NO_NOTIFICATIONS: 'No notifications',
  },
  TRANSACTIONS: {
    TITLE: 'Transaction history',
    CREATED_AT: 'Date',
    USER: 'User',
    CHANGED_AMOUNT: 'Changed amount',
    CURRENCY_RATE: 'Currency rate',
    MONEY_TYPE: 'Money type',
    TYPE: 'Type',
    AMOUNT_DIRTY: 'Amount in transaction currency',
    AMOUNT_CLEAR: 'Amount in balance currency',
    AMOUNT: 'Amount',
    RATE: 'Rate',
    CREATE_INCOME: 'Create income',
    CREATE_TRANSFER: 'Create transfer',
    BALANCE_TRANSFER: 'Balance transfer',
    BALANCE_INCOM: 'Balance income',
    BOX_ISSUED: 'Box issued',
    BOX_HANDED: 'Box handed',
    BANK_HANDED: 'Bank handed',
    CURRENT_BALANCE: 'Current balance',
    CURRENCY: 'Currency',
    BALANCE_INFO: 'Balance information',
    CURRENT_COUNT: 'Current count',
    COUNT_CHANGE: 'Count change',
    TAX_STICKER_INFO: 'Tax sticker information',
    TAX_STICKER: 'Tax sticker',
  },
  ACCOUNTABLE: {
    ACCOUNTABLE: 'Accountable',
    NAME: 'Name',
    ROLES: 'Roles',
    CASH_BALANCE: 'Balance',
    TAX_STICKERS: 'Tax stickers',
    ADD_TAX_STICKER: 'Issue tax sticker',
    REMOVE_TAX_STICKER: 'Return tax sticker',
    ADD_BANK: 'Deposit cash to bank',
    ADD_OFFICE: 'Deposit cash to office',
    ADD_SELF: 'Add cash to balance',
    AMOUNT: 'Amount',
    VIEW_TRANSACTIONS: 'Transaction history',
    BALANCES: 'Balances',
    CASH: 'Cash',
    COUNT: 'Count',
    TAX_STICKER: 'Tax sticker',
    ADD_EXPENSE: 'Expense',
    TRANSFER_CASH: 'Transfer to another balance',
    TO: 'To whom to transfer',
    SELECT_USER: 'Select user',
    COMMENT: 'Comment',
  },
  CHATS_CENTER: {
    TITLE: 'Chat center',
    CREATE_CHAT: 'Create chat',
    CHAT_CREATION_FAILED: 'Failed to create chat',
    CHAT_CREATION_SUCCESSFULLY: 'Chat created successfully',
    TOPIC: 'Chat topic',
    MESSAGE: 'Message',
    FILES: 'Files',
    ADD_CHAT: 'Add chat',
    SELECT_PARTICIPANTS: 'Select participants',
    PARTICIPANTS: 'Participants',
    CHAT_PARTICIPANTS_ADDED_SUCCESSFULLY: 'Participants added successfully',
    CHAT_PARTICIPANTS_ADDED_FAILED: 'Failed to add participants',
    NO_CHATS: 'No chats found',
    UNNAMED_CHAT: 'Unnamed chat',
    NO_MESSAGES: 'No messages yet',
    EMPTY_MESSAGE: 'Empty message',
    YESTERDAY: 'Yesterday',
    TWO_DAYS_AGO: 'Two days ago',
    CHAT: 'Chat',
    TYPE_MESSAGE: 'Type a message...',
    SEND: 'Send',
    ATTACH_FILES: 'Attach files',
    ADD_PARTICIPANTS: 'Add participants',
    REMOVE_PARTICIPANT: 'Remove participant',
    MESSAGE_SEND_FAILED: 'Failed to send message',
    MESSAGES_LOAD_FAILED: 'Failed to load messages',
    MUTE: 'Disable notifications',
    UNMUTE: 'Enable notifications',
  },
};
